import { motion } from "framer-motion";
import { Sparkles, CreditCard, FileText } from "lucide-react";

/**
 * Shared "Practice Model & Investment" section — clarifies private-pay
 * boutique model, HSA/FSA acceptance, and OON superbill reimbursement.
 * Rendered on Homepage, FAQ, Fees, DC Package, and Group Immersion pages.
 */
export const PracticeModelInvestment = ({ background = "bg-white" }) => (
  <section
    className={`py-20 md:py-24 px-6 md:px-12 ${background}`}
    data-testid="practice-model-section"
  >
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="inline-flex items-center gap-2 text-primary font-medium text-sm uppercase tracking-[0.18em]">
          <Sparkles className="h-4 w-4" />
          How This Practice Works
        </span>
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mt-4 leading-tight">
          Practice Model &amp; Investment
        </h2>

        <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
          Divine Love Wellness Enterprises operates as a{" "}
          <span className="font-semibold text-foreground">
            boutique, private-pay practice
          </span>{" "}
          to ensure total clinical privacy, bespoke pacing, and care unconstrained
          by third-party insurance mandates. All services are{" "}
          <span className="font-semibold text-foreground">
            out-of-network (OON)
          </span>
          .
        </p>

        <div className="mt-8 space-y-5">
          <div className="flex items-start gap-4 p-5 rounded-2xl bg-accent/10 border border-accent/30">
            <div className="p-2 rounded-full bg-accent/20 flex-shrink-0">
              <CreditCard className="h-5 w-5 text-accent" />
            </div>
            <div>
              <h3 className="font-serif text-lg font-semibold text-foreground">
                HSA/FSA Cards Accepted
              </h3>
              <p className="mt-1 text-base text-muted-foreground leading-relaxed">
                You may pay for services directly using your Health Savings
                Account (HSA) or Flexible Spending Account (FSA) debit card.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-5 rounded-2xl bg-primary/5 border border-primary/20">
            <div className="p-2 rounded-full bg-primary/15 flex-shrink-0">
              <FileText className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="font-serif text-lg font-semibold text-foreground">
                Out-of-Network Reimbursement
              </h3>
              <p className="mt-1 text-base text-muted-foreground leading-relaxed">
                Itemized clinical superbills are provided for clients seeking
                direct reimbursement through their out-of-network insurance
                benefits.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default PracticeModelInvestment;
